
import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { FaEnvelope, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../components/LanguajeContext";
import { forgotTranslation } from "../utils/forgotpassword.translate";

export default function ForgotPassword() {
  const URL = process.env.REACT_APP_SERVER_URL

  const { language } = useLanguage();
  const t = forgotTranslation[language];

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${URL}/api/authOperator/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setIsError(false);
        setMessage(data.message || t.success);
      } else {
        setIsError(true);
        setMessage(data.error || t.error);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsError(true);
      setMessage(t.networkError);
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
        setIsError(false);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <Navbar />

      <div className="min-h-screen bg-[#102B3F] flex items-center justify-center p-6">
        <div className="bg-[#335066] text-white w-full max-w-md p-8 rounded-2xl shadow-2xl mt-12">

          {/* Título */}
          <h2 className="text-3xl font-bold mb-6 text-center text-green-300">
            {t.title}
          </h2>
          <p className="text-sm text-gray-300 text-center mb-6">
            {t.subtitle}
          </p>

          {/* Mensajes */}
          {message && (
            <div
              className={`flex items-center gap-2 p-3 mb-5 rounded-lg text-sm font-medium border-l-4 ${
                isError
                  ? "bg-red-100 text-red-800 border-red-500"
                  : "bg-green-100 text-green-800 border-green-500"
              }`}
            >
              {isError ? (
                <FaExclamationCircle className="text-lg" />
              ) : (
                <FaCheckCircle className="text-lg" />
              )}
              <span>{message}</span>
            </div>
          )}

          {/* Formulario */}
          <form onSubmit={handleSubmit} className="space-y-5">

            <div className="relative">
              <label className="block mb-1 text-sm">{t.emailLabel}</label>

              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.emailPlaceholder}
                className="w-full p-3 pr-10 rounded bg-[#2D4A5E] border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-400"
                required
              />

              <FaEnvelope className="absolute right-3 top-11 text-black" />
            </div>

            <button
              type="submit"
              className="w-full bg-green-400 text-black font-semibold py-2 rounded-lg hover:bg-green-300 transition"
            >
              {t.sendButton}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="text-sm text-green-300 hover:text-green-200 underline transition"
            >
              {t.backToLogin}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
